import {createAsyncThunk} from '@reduxjs/toolkit';
import { api } from '../../helpers/api_helper';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';
  

export const businessInfo = createAsyncThunk('vendor/info', async (info, thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.BUREAU.GET);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

